type CookieConsent = {
  analytics: boolean;
  necessary: boolean;
  preferences: boolean;
  timestamp: number;
};

export const CookieManager = {
  setCookie(name: string, value: string, days: number = 365) {
      const expires = new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
  },

  getCookie(name: string): string | null {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for(let i = 0; i < ca.length; i++) {
          let c = ca[i].trim();
          if (c.indexOf(nameEQ) === 0) {
              return c.substring(nameEQ.length, c.length);
          }
      }
      return null;
  },

  setConsent(consent: CookieConsent) {
      this.setCookie('cookie_consent', JSON.stringify(consent));

      // Si analytics est accepté, initialiser GA
      if (consent.analytics && import.meta.env.VITE_GA_MEASUREMENT_ID) {
          (window as any).gtag?.('consent', 'update', {
        'analytics_storage': 'granted'
          });
      }
  },

  getConsent(): CookieConsent | null {
      const consent = this.getCookie('cookie_consent');
      return consent ? JSON.parse(consent) : null;
  },

  hasConsent(): boolean {
      return !!this.getCookie('cookie_consent');
  }
};
